import axios from "axios";

import { BACKEND } from "@/lib/backend";

export { BACKEND };
export const portalApi = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const adminApi = axios.create({ baseURL: `${BACKEND}/api/olta` });
adminApi.interceptors.request.use((c) => {
  const t = localStorage.getItem("olta_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const formatCode = (v) => {
  const c = (v || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 12);
  return c.match(/.{1,4}/g)?.join("-") || "";
};

export function detail(e, fallback = "Etwas ist schiefgelaufen.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).join(" ");
  return fallback;
}
